<template>
  <section class="guild-select-container">
    <GuildCard 
      v-on:refresh="$emit('refresh')"
      v-for="(editableGuild, i) in editableGuilds"
      v-bind:guild="editableGuild"
      v-bind:key="editableGuild.id"
      v-bind:type="`e`"
      :style="`animation-delay: ${i*0.2}s`"
    />
    <GuildCard 
      v-on:refresh="$emit('refresh')"
      v-for="(invitableGuild, i) in invitableGuilds"
      v-bind:guild="invitableGuild"
      v-bind:key="invitableGuild.id"
      v-bind:type="`i`"
      :style="`animation-delay: ${(editableGuilds.length*0.2)+i*0.2}s`"
    />
  </section>
</template>

<script>
import GuildCard from "@/components/GuildCard.vue";

export default {
  name: "GuildContainer",
  props: ["editableGuilds", "invitableGuilds"],
  components: {
    GuildCard
  }
}
</script>

<style scoped>
  .guild-select-container {
    text-align: center;
    display: flex;
    align-items: center;
    align-content: center;
    flex-direction: column;
    transition: 0.5s;
  }

  @media screen and (min-width: 700px) {
    .guild-select-container {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
    }
  }
</style>